import { render } from "./index.vue?vue&type=template&id=1ea2c5d4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "E:\\web\\duty_new_2\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_9f64b88eef0ad2be2f27cb0deb411dda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__